import { v4 as uuidv4 } from "uuid";
import storageX from "../storageCore/storageX";
import { STORAGE_KEY_UUID } from "../storageCore/constStorageKeys";

/**
 * Garante UUID de dispositivo antes de solicitar token WSO2.
 * Sem isso o scope fica "devices_<fingerprint>-null" e a API responde 403.
 */
export function ensureDeviceUuid(): string {
  let uuid = storageX.whereKeyIs(STORAGE_KEY_UUID).get();
  if (!uuid || uuid === "null" || uuid === "undefined") {
    uuid = uuidv4();
    storageX.whereKeyIs(STORAGE_KEY_UUID).set(uuid);
  }
  return String(uuid);
}
